import React from 'react';
import ContainerList from './ContainerList';

export default function MainView() {
    return (
        <div>
            <h1 className="discovery-header">Search Codecademy's Catalog</h1>
            { <ContainerList /> }
        </div>
    )
}